export const PENDING_COUNT_OVERFLOW = 99;
export function getPendingCountLabel(count) {
    if (count > PENDING_COUNT_OVERFLOW) {
        return `${PENDING_COUNT_OVERFLOW}+`;
    }
    return String(count);
}
/** 按数量分档：个位 / 十位 / 溢出，用于圆形尺寸与字号 */
export function getPendingCountTier(count) {
    if (count > PENDING_COUNT_OVERFLOW) {
        return 'l';
    }
    if (count > 9) {
        return 'm';
    }
    return 's';
}
